export default "__VITE_ASSET__Bmvszzt2__"